import { render, staticRenderFns } from "./WhyWe.vue?vue&type=template&id=79e37a38&"
import script from "./WhyWe.vue?vue&type=script&lang=js&"
export * from "./WhyWe.vue?vue&type=script&lang=js&"
import style0 from "./WhyWe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports